const user = () => import('@/pages/statistics/user/index.vue');

export default [{
    path: '/statistics/user',
    component: user,
    meta: [{
        name: '统计分析'
    },
    {
        name: '用户分析',
        activeRoute: '/statistics/user'
    }]
}];